<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1z62VD/tc-custom/9781609458515.jpg?1697129241275" alt="This image is the cover for the book Eyes of Venice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eyes of Venice
      </h1>
      <p class="bookDescription body article font2">
        <b>A young Venetian man and woman face hardship and high seas adventure across the Mediterranean in this prize-winning novel set during the Renaissance.</b><br/><br/>Venice of the late sixteenth century is an unforgiving city. The Doge rules with an iron fist and the Holy Office of Inquisition harbors suspicions about everything and everyone. It is a place where even the walls have eyes. So when a recently married stonemason by the name of Michele is accused of a crime he didn’t commit, he flees for his life aboard a galley—leaving behind his young wife, Bianca.<br/><br/>Determined to clear his name and return to his love, Michele embarks on extraordinary adventures as the ship stops at every port and island on its way across the sea. Meanwhile, Bianca struggles to survive alone in Venice, where she faces all the terrors and mysteries that the labyrinthine city holds in its blind alleys and narrow passageways. To survive, they must each find every ounce of cunning, courage, and fortitude within themselves.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alessandro Barbero, Gregory Conti
      </h2>
      
      <p class="authorDescription body article">Alessandro Barbero is the author of The Battle: A New History of Waterloo (Walker & Co., 2005), and Charlamagne: Father of a Continent, and Master Pyle’s Bella Vita and Other People’s Wars, winner of the Strega Prize for Fiction. He is a renowned historian whose two-volume history of the Battle of Lepanto is considered to be the definitive text on the subject. He teaches Medieval History at the University of Eastern Piedmont in Vercelli, Italy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79f4309a